module.exports = __webpack_public_path__ + "img/search-button.aea82a00660d88bdcdcdee5d0c641eec.svg";